//Componentes generales
import { useContext, useEffect } from 'react';
import {
    Route,
    Routes
} from "react-router-dom";

//Views
import Login from "../../views/login/Login";
import Home from "../../views/home/Home";
import User from "../../views/user/User";
import Provider from '../../views/provider/Provider.js';
import Product from "../../views/product/Product";
import SharedLayout from "../../components/sharedLayout/SharedLayout";
import AddReq from "../../views/addReq/AddReq";
import Grupos from '../../views/Grupos/Grupos';
import CtaCorriente from '../../views/ctaCorriente/CtaCorriente.js';
import Solicitudes from '../../views/solicitudes/Solicitudes.js';
import PagosYReten from '../../views/pagosYreten/PagosYReten.js';
import ValidDatos from '../../views/ValidDatos/ValidDatos.js';
import Subcuenta from '../../views/Subcuenta/Subcuenta.js';
import PageABMs from '../../views/pageABMs/PageABMs.js';
import GlobalSettings from '../../views/globalSettings.js/GlobalSettings.js';

//Rutas
import Routes_gral from "../Routes_gral";

import authContext from "../../context/authentication/authContex";

//Token
import tokenAuth from "../../config/token";


// Revisar si tenemos un token
const token = localStorage.getItem('token');

if (token) {
    tokenAuth(token);
}


function Rutas() {

    //Context de Autenticacion   
    const aContext = useContext(authContext);
    const { usuarioAutenticado } = aContext;

    useEffect(() => {
        usuarioAutenticado()
    }, []);

    return (
        <div className="App">
            <Routes>
                <Route path={Routes_gral.login} element={<Login />} />
                <Route path={Routes_gral.group} element={<SharedLayout section={"Grupos"}> <Grupos /> </SharedLayout>} />
                <Route path={Routes_gral.home} element={<SharedLayout section={"Home"}> <Home /> </SharedLayout>} />
                <Route path={Routes_gral.validDatos} element={<SharedLayout section={"Mis Datos"}> <ValidDatos /> </SharedLayout>} />
                <Route path={Routes_gral.solicitudes} element={<SharedLayout section={"Solicitudes"}> <Solicitudes /> </SharedLayout>} />
                <Route path={Routes_gral.ctaCorriente} element={<SharedLayout section={"Cuenta Corriente"}> <CtaCorriente /> </SharedLayout>} />
                <Route path={Routes_gral.pagosYreten} element={<SharedLayout section={"Pagos y Retenciones"}> <PagosYReten /> </SharedLayout>} />
                <Route path={Routes_gral.addReq} element={<SharedLayout section={"Nuevo Comprobante"}> <AddReq edicion={false} /> </SharedLayout>} />
                <Route path={Routes_gral.user} element={<SharedLayout section={"Usuarios"}> <User /> </SharedLayout>} />
                <Route path={Routes_gral.provider} element={<SharedLayout section={"Proveedores"}> <Provider /> </SharedLayout>} />
                <Route path={Routes_gral.subcuentas} element={<SharedLayout section={"Subcuentas"}> <Subcuenta /> </SharedLayout>} />
                <Route path={Routes_gral.product} element={<SharedLayout section={"Productos"}> <Product /> </SharedLayout>} />
                <Route path={Routes_gral.abms} element={<SharedLayout section={"ABMs"}> <PageABMs /> </SharedLayout>} />
                <Route path={Routes_gral.globalSettings} element={ <SharedLayout section={"Configuración Global"}><GlobalSettings/></SharedLayout> } />
            </Routes>
        </div>
    );
}

export default Rutas;
